import { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// Create Context
const RoleContext = createContext();

// Custom hook
export const useRole = () => useContext(RoleContext);

export const RoleProvider = ({ children }) => {
  const navigate=useNavigate();
  const {roles} = useSelector((state)=> state?.authReducer)
  const availableRoles = roles || [];

  const [selectedRole, setSelectedRole] = useState(() => {
    // ✅ Load saved role from localStorage if available
    return localStorage.getItem("selectedRole") || null;
  });

  // ✅ Sync selectedRole with availableRoles (e.g., after profile load)
  useEffect(() => {
    if (availableRoles?.length > 0) {
      setSelectedRole((prev) => {
        const saved = localStorage.getItem("selectedRole");

        // If saved role exists and is valid → keep it
        if (saved && availableRoles?.includes(saved)) return saved;

        // Else → fallback to first available
        const defaultRole = availableRoles?.[0];
        localStorage.setItem("selectedRole", defaultRole);
        return defaultRole;
      });
    }
  }, [availableRoles]);

  // ✅ Whenever selectedRole changes → persist it
  useEffect(() => {
    if (selectedRole) {
      localStorage.setItem("selectedRole", selectedRole);
    }
  }, [selectedRole]);

  // ✅ Switch role logic
  const switchRole = () => {
    if (availableRoles?.length === 1) {
      return;
    }

    if (availableRoles?.includes("artist") && availableRoles?.includes("agency")) {
      setSelectedRole((prev) => {
        const newRole = prev === "agency" ? "artist" : "agency";
        localStorage.setItem("selectedRole", newRole);
        return newRole;
      });
    } else {
      console.warn("Roles do not support switching automatically");
    }
    navigate("/profile")
  };

  return (
    <RoleContext.Provider
      value={{ availableRoles, selectedRole, switchRole }}
    >
      {children}
    </RoleContext.Provider>
  );
};
